import React from "react";
import { twMerge } from "tailwind-merge";
import Element from "src/components/base/element";
import MediaLeft from "./left";
import MediaRight from "./right";
import MediaItem from "./item";
import MediaContent from "./content";

interface IProps {
    className?: string;
    children: React.ReactNode;
    domRef?: any;
}

function Media(props: IProps) {
    const { className, children, domRef, ...rest } = props;
    return (
        <Element
            {...rest}
            className={twMerge(
                "media",
                "flex items-center",
                "p-[10px] rounded-[5px]",
                "text-left select-none",
                className,
            )}
            domRef={domRef}
        >
            {children}
        </Element>
    );
}

Media.Left = MediaLeft;
Media.Right = MediaRight;
Media.Item = MediaItem;
Media.Content = MediaContent;

export default Media;
